import { Goal } from 'generated/graphql';
import styled from 'styled-components';
import { Expand, Heading, Skeleton } from '@treams/treams-ui';
import { Flex } from 'reflexbox';
import { SubgoalsContext } from 'goals/subgoals/Subgoals';
import { t } from 'i18next';
import GoalDescription from './GoalDescription';

const SubgoalsContent = styled.div`
	padding-left: 40px;
`;

const Subgoals = styled.div`
	border-top: 1px solid #e0e0e0;
	margin: 0;
	padding: 15px;
`;

const StyledGoalContent = styled.div`
	box-sizing: border-box;

	// Expand can't handle margins so we need to add whitespace as a border
	border-top: 5px solid white;
	background-color: ${({ theme }) => theme.colors.whiteBlue};
`;

export default Skeleton(
	function GoalContent({ goal, collapsed }: { goal: Goal; collapsed: boolean }) {
		return (
			<Expand expanded={!collapsed}>
				<StyledGoalContent>
					<GoalDescription competencyGoal={goal.competency!} />
					<Subgoals>
						<Heading mb={3}>
							<Flex alignItems="center">{t('developmentPlan.index.goalChecklistTitle')}</Flex>
						</Heading>
						<SubgoalsContent>
							<SubgoalsContext goal={goal as Goal} editable={true} />
						</SubgoalsContent>
					</Subgoals>
				</StyledGoalContent>
			</Expand>
		);
	},
	function GoalContentSkeleton() {
		return <Skeleton.Box height={200} mt={1} />;
	},
);
